import { graphql, useStaticQuery } from "gatsby"
import { useLocale } from ".."

export const useSiteQueryFour = () => {
  const locale = useLocale()

  const {
    allContentfulDigitupGlobalTextFields: { edges },
  } = useStaticQuery(
    graphql`
      query globalTextFields {
        allContentfulDigitupGlobalTextFields {
          edges {
            node {
              node_locale
                newsletterThankYou
                thankYou
                perksAndBenefitsText
                search
                searchPageLocalizedPlaceholder
                contactUsPhoneError
                pageSearchBlogHeading
                pageNotFoundContent{
                  raw
                }
                pageNotFound{
                gatsbyImageData
                title
                }
                languageSwitcherText
                allResources
                blogTexts{
                    all
                    posted
                    readText
                    writtenBy
                    editedDate
                    listenBlog
                    readMoreText
                    inThisArticle
                }
                jobTexts{
                    jobInformation  
                    aboutJob  
                    departmentName  
                    workExperience  
                    dateOpened  
                    locationText  
                    jobType  
                    jobsFound 
                }
            }
          }
        }
      }
    `
  )

  const localeData = locale
    ? edges.filter(({ node }) => node.node_locale === locale)
    : edges.filter(({ node }) => node.node_locale === "en-US")
  const site = localeData.reduce((acc, val) => ({ ...acc, ...val.node }), {})


  return site
}
